<template>
  <div
    v-show="$store.getters.isTop"
    class="p-main"
    :class="{'p-main--show': $store.getters.isTop}"
  >
    <div ref="p-main__mv" class="p-main__mv">
      <div ref="video-frame" class="p-main__mvBg">
        <video ref="video-src" :src="bgMovie" autoplay loop muted playsinline></video>
        <div ref="p-main__mvLogo" class="p-main__mvLogo" :style="setStyleLogo()">
          <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 165.1 841.9 265.1" viewBox="0 165.1 841.9 265.1" width="842" height="265">
            <g fill="#fff">
              <path d="m763.2 397.6c-3.1 3.1-6.1 4.9-9.2 4.9-1.2 0-2.5-.6-3.1-1.2-2.5-1.8-3.7-4.9-3.7-9.8 0-2.5.6-4.9 1.2-8.6.6-3.1 1.2-8.6 2.5-16.6l3.7-22.1 2.5-15.4 24.5-150.8c-246.6 51-414.5 84.9-522.7 105.8 0-.6 0-.6 0-1.2 0-6.8-1.2-12.9-3.1-18.4-4.9-16-16.6-24-35.1-24-1.8 0-3.1 0-4.9 0-14.7 1.2-25.8 9.8-33.8 25.8-4.3 9.2-8 20.3-10.5 34.4-23.4 4.3-41.2 8-54.1 10.5l-6.1-3.1c-9.2-4.9-11.7-6.8-21.5-13.5-8.6-6.1-13.5-12.9-15.4-20.9-.6-1.8-.6-4.3-.6-6.8 0-3.1.6-6.8 1.2-11.1 2.5-13.5 9.8-22.1 22.1-26.4 2.5-.6 4.9-1.2 7.4-1.2 1.8 0 3.7 0 5.5.6.6 0 1.2.6 1.8.6 0 0 .6 0 .6.6.6.6 1.8 1.8 0 2.5-.6.6-1.2.6-1.8 1.2-.6 0-.6.6-.6.6-1.8 1.8-3.1 3.7-3.7 5.5 0 .6-.6.6-.6 1.2-.6 1.8-1.2 3.7-1.2 6.1 0 4.9 1.8 9.2 5.5 12.3 3.7 3.7 8 5.5 12.9 5.5 4.3 0 8.6-1.8 11.7-4.9s5.5-7.4 6.1-13.5c0 0 .6-7.4-2.5-11.7-1.8-3.1-3.7-5.5-6.1-8-8-8-16-12.3-32.6-14.1-4.9-.6-9.2-.6-14.1 0-8.6.6-13.5 1.2-18.4 1.8-14.8 3.1-25.2 9.8-31.4 20.9-4.9 8-7.4 16.6-7.4 25.2 0 2.5 0 4.9.6 7.4 2.5 13.5 10.5 24 24.6 32 0 0 4.9 2.5 14.8 7.4 9.8 4.9 18.4 10.5 18.4 10.5-44.8 11.1-62 15.4-78.6 36.3-5.5 6.8-8 14.8-8 22.1 0 3.1 0 5.5.6 8.6 1.8 9.2 6.8 17.2 15.4 24.6 15.4 13.5 37.5 20.9 65.2 20.9h3.1c27.1-.6 47.4-8 61.5-22.8 9.8-10.5 14.8-22.8 14.8-36.3 0-4.9-.6-9.2-1.8-14.8-1.8-9.2-6.1-23.4-26.4-36.3 9.8-2.5 22.8-5.5 38.1-9.2-1.2 9.8-2.5 20.3-3.1 32v8c0 24 4.9 42.4 14.8 56.6 9.2 13.5 22.1 20.3 37.5 21.5h4.3c11.7 0 22.1-3.1 32-9.8 3.7-2.5 6.8-4.9 9.2-7.4 6.1 10.5 16 16 29.5 16.6h1.2c11.7 0 20.9-4.3 27.1-12.9 3.1 6.8 10.5 11.1 20.3 12.3 3.1.6 6.1.6 9.2.6s6.1-.6 8.6-1.2c5.5-1.8 10.5-4.9 14.8-9.2l-1.8 10.5h33.2l15.4-94.1c5.5-3.7 9.8-6.1 12.9-6.1h1.2c2.5.6 3.7 3.1 4.3 6.8v.6c0 3.7-.6 10.5-2.5 19.7-3.7 20.3-6.1 35.7-6.1 45.5 0 4.3.6 7.4 1.2 9.8 2.5 8.6 9.2 14.1 20.3 16 3.1.6 6.1.6 9.2.6 3.7 0 6.8-.6 9.8-1.8 6.8-2.5 12.9-6.8 18.4-13.5.6-.6 1.2-1.8 1.8-2.5 2.5 8.6 8.6 14.1 19.1 16.6 4.3.6 8 1.2 11.1 1.2s6.1-.6 8.6-1.2c10.5-3.7 19.1-12.3 26.4-27.1 2.5 4.3 4.9 8 8.6 11.7 5.5 5.5 11.7 9.8 19.1 12.9 6.8 2.5 12.9 3.7 19.1 4.3h.6c14.1 0 27.1-4.3 38.7-12.3 4.3-3.1 8.6-6.8 12.3-11.1 6.1 14.8 16.6 22.1 32.6 22.8h1.2c11.7 0 20.9-4.3 26.4-12.9 3.7 6.8 10.5 11.1 20.3 12.3 3.1.6 6.1.6 9.2.6s6.1-.6 8.6-1.2c14.1-4.9 25.8-20.9 34.4-47.4h-14.1c-4.8 9.2-8.5 15.4-12.2 19.1zm-642.1-13.6c-1.8 7.4-4.9 14.1-9.2 19.7-3.7 4.9-6.8 6.8-11.7 8.6-5.5 2.5-11.1 3.7-19.7 3.7s-19.1-3.1-27.7-9.8c-5.5-4.3-9.8-12.3-10.5-22.1-.6-6.1.6-11.1 1.2-14.8 4.3-17.2 24-30.7 56.6-41.2 0 0 22.8 15.4 22.1 40.6 1.4 6.1.8 10.4-1.1 15.3zm88-97.7c3.1-14.8 9.2-24.6 17.8-30.1 3.1-2.5 6.1-3.1 9.2-3.7h.6c2.5 0 4.3.6 5.5 2.5 2.5 3.1 3.7 7.4 3.7 12.9s-1.2 11.7-3.7 19.1c-12.3 2.5-24 4.9-35.1 6.8.8-2 1.4-4.5 2-7.5zm-8 59.6c0-12.3 1.8-27.1 4.9-44.3 10.5-2.5 22.1-4.9 33.8-7.4-1.8 4.9-4.3 9.8-6.8 16-2.5 4.9-6.1 11.7-11.7 19.1-6.8 9.2-13.5 16-20.3 20.9v-4.3zm121.8 12.9c-1.8 14.8-4.3 25.2-7.4 31.4-1.2 3.1-3.7 4.9-6.8 5.5-1.2.6-2.5.6-3.7.6s-3.1-.6-4.9-.6c-3.1-1.2-5.5-3.1-7.4-5.5-2.5-3.1-3.7-6.8-3.7-10.5 0-2.5 0-4.9 0-7.4 0-11.1 1.8-20.3 5.5-27.7 3.7-8.6 8.6-13.5 14.8-14.1h2.5c3.7 0 6.8 1.2 9.2 3.1 2.5 2.5 3.7 5.5 4.3 9.8v1.2c-1.2 1.9-1.8 6.8-2.4 14.2zm260.1 12.9c-.6-2.5-.6-4.9-.6-8 0-1.2 0-3.1 0-4.3 0-10.5 1.8-19.1 5.5-27.1 4.3-9.2 10.5-14.1 18.4-16.6 2.5-.6 4.9-1.2 6.8-1.2h1.8c3.7.6 4.9 1.8 4.9 4.9 0 1.2 0 2.5-.6 3.7-1.2 3.1-4.3 8.6-9.8 16.6-8 13.6-16.6 24-26.4 32zm131 1.9c-1.8 8.6-3.1 14.1-4.9 17.2-1.2 3.1-3.7 4.9-6.1 5.5-1.2.6-2.5.6-3.7.6s-3.1 0-4.3-.6c-6.8-2.5-10.5-8-11.1-16.6 0-2.5 0-4.9 0-7.4 0-10.5 1.8-19.7 4.9-27.7 3.7-8.6 8.6-12.9 14.8-13.5h1.8c3.7 0 6.8 1.2 9.2 3.1 2.5 2.5 3.7 5.5 4.3 9.8-1.8 9.9-3.1 19.7-4.9 29.6zm8-62.1c-6.8-5.5-12.3-8.6-18.4-8.6-1.8 0-3.7 0-5.5 0-8 0-14.8 1.2-19.7 4.3-12.9 7.4-21.5 22.8-25.8 46.7-1.2 7.4-1.8 14.8-1.8 21.5 0 4.3 0 8.6.6 12.3-1.2 1.2-2.5 2.5-4.3 4.3-8 6.8-17.2 10.5-27.7 10.5-1.8 0-3.1 0-4.9 0-12.3-1.2-20.9-6.8-25.8-16.6 36.9-11.7 56.6-27.7 58.4-49.2 0-1.2 0-2.5 0-3.7 0-8.6-3.1-15.4-8.6-20.3-3.1-2.5-6.8-4.9-10.5-6.8-4.3-1.8-10.5-3.1-17.8-3.1h-3.7c-6.8 0-14.1 1.8-21.5 6.1-16.6 8.6-26.4 24.6-30.7 48-1.2 5.5-1.2 10.5-1.2 15.4 0 2.5 0 5.5.6 8-3.1 7.4-6.8 13.5-10.5 17.2-3.1 3.1-6.1 4.9-8.6 4.9-1.2 0-2.5-.6-3.7-1.2-2.5-1.8-3.7-4.9-3.7-9.8 0-2.5.6-4.9 1.2-8.6.6-3.1 1.2-8.6 2.5-16.6l3.7-22.1 3.7-25.2h13.5l2.5-17.2h-12.9c1.2-9.2 1.8-11.1 3.7-20.3.6-2.5.6-4.9.6-7.4 0-4.9-.6-9.2-2.5-13.5-3.7-8.6-11.1-13.5-22.1-13.5h-18.1c1.8 1.8 3.1 4.9 4.3 8.6 1.8 4.9 3.1 9.8 3.1 15.4 0 2.5 0 4.9-.6 7.4-.6 3.1-1.2 6.1-3.7 24h-13.5l-2.5 17.2h12.9c-3.1 17.8-4.9 29.5-4.9 33.8-1.8 10.5-2.5 19.7-3.7 27.1-3.1 8-6.8 13.5-10.5 17.2-1.8 1.8-4.3 3.7-6.1 4.3-1.2.6-1.8.6-2.5.6-1.2 0-2.5 0-3.1-.6-2.5-1.2-3.7-4.9-3.7-9.2 0-2.5.6-4.9 1.2-8.6.6-3.1 1.2-8.6 2.5-16.6 3.7-15.4 4.9-27.7 4.9-36.9 0-3.7 0-7.4-.6-9.8-2.5-10.5-8.6-16-18.4-16.6-.6 0-1.2 0-1.8 0-8.6 0-17.8 4.9-28.3 15.4l2.5-13.5c0-.6 0-1.2 0-1.8h-54.7c6.8 0 11.1 5.5 12.3 16 .6 2.5.6 4.9.6 7.4 0 3.1 0 5.5-.6 8.6-1.8 11.1-2.5 17.8-2.5 19.7l-3.7 25.2c-2.5 8.6-4.9 13.5-8.6 17.2-3.1 3.1-4.9 3.7-8 4.9-1.2.6-2.5.6-3.1.6-1.2 0-2.5 0-3.1-.6-2.5-1.8-3.7-4.9-3.7-9.8 0-2.5.6-4.9 1.2-8.6l2.5-16.6 3.7-22.8 6.8-42.4h-36.9l-1.8 11.7-1.8-1.8c-6.8-5.5-12.9-8.6-18.4-9.2-1.8 0-3.7 0-5.5 0-8 0-14.8 1.2-19.7 4.9-12.9 7.4-21.5 22.8-25.8 46.7-1.2 7.4-1.8 14.8-1.8 21.5s.6 12.9 1.8 19.1c-7.4 5.5-14.8 8.6-22.8 8.6-2.5 0-4.3 0-6.8-.6-9.8-1.8-16-7.4-18.4-16.6 17.2-19.7 30.7-42.4 40.6-68.3 3.7-9.2 6.1-18.4 6.8-26.4 112.5-24.6 280.4-59 474.8-90.4 2.5-.6 7.4-.6 6.8 4.9l-8.6 56.6v1.8l-7.4 49.8z"/><path d="m811.1 172.5-21.5 4.3-.6 4.3 8.6-1.8-3.7 23.3 4.3-.6 4.3-23.4 8-1.8z"/><path d="m835.7 167-11 24.6-3.7-21.6-6.8 1.9-4.3 28.3 4.3-1.3 3.7-21.5 3.7 20.3 3.7-.6 11.1-24-3.1 22.8 4.3-.7 4.3-30.1z"/>
            </g>
          </svg>
          <p>VFX / CGI<br />TOKYO</p>
        </div>
      </div>
      <div class="p-main__mvScroll" @click="mvScroll">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74 15" width="74" height="15">
          <path fill-rule="evenodd" fill="rgb(255, 255, 255)" d="M64.610,14.150 L64.610,0.347 L67.410,0.347 L67.410,11.789 L73.212,11.789 L73.212,14.150 L64.610,14.150 ZM53.410,0.347 L56.210,0.347 L56.210,11.789 L62.12,11.789 L62.12,14.150 L53.410,14.150 L53.410,0.347 ZM45.71,14.330 C41.970,14.330 39.790,12.449 39.790,8.228 L39.790,6.268 C39.790,2.7 41.970,0.167 45.71,0.167 C48.191,0.167 50.372,2.7 50.372,6.268 L50.372,8.228 C50.372,12.449 48.191,14.330 45.71,14.330 ZM47.571,6.268 C47.571,3.627 46.691,2.527 45.71,2.527 C43.450,2.527 42.590,3.627 42.590,6.268 L42.590,8.228 C42.590,10.869 43.450,11.969 45.71,11.969 C46.691,11.969 47.571,10.869 47.571,8.228 L47.571,6.268 ZM34.531,14.150 L32.51,8.728 L29.810,8.728 L29.810,14.150 L27.10,14.150 L27.10,0.347 L31.951,0.347 C35.132,0.347 37.112,1.767 37.112,4.567 C37.112,6.428 36.252,7.648 34.751,8.268 L37.612,14.150 L34.531,14.150 ZM31.691,2.727 L29.810,2.727 L29.810,6.368 L31.691,6.368 C33.351,6.368 34.311,6.8 34.311,4.567 C34.311,3.127 33.351,2.727 31.691,2.727 ZM18.671,2.527 C17.50,2.527 16.190,3.627 16.190,6.268 L16.190,8.228 C16.190,10.789 17.50,11.969 18.671,11.969 C20.71,11.969 20.751,11.269 21.51,9.869 L23.712,9.869 C23.252,12.969 21.511,14.330 18.671,14.330 C15.570,14.330 13.390,12.449 13.390,8.228 L13.390,6.268 C13.390,2.7 15.570,0.167 18.671,0.167 C21.411,0.167 23.272,1.607 23.732,4.627 L21.51,4.627 C20.791,3.327 20.31,2.527 18.671,2.527 ZM11.32,10.309 C11.32,12.569 9.511,14.330 6.271,14.330 C3.850,14.330 2.170,13.669 0.950,12.69 L3.90,10.589 C3.830,11.509 4.670,11.969 6.91,11.969 C7.691,11.969 8.231,11.269 8.231,10.429 C8.231,9.469 7.651,8.928 5.411,8.348 C2.690,7.628 1.330,6.328 1.330,4.47 C1.330,1.867 2.770,0.167 6.51,0.167 C8.251,0.167 9.912,0.907 10.892,2.427 L8.791,3.927 C8.191,2.987 7.471,2.527 6.71,2.527 C4.810,2.527 4.130,3.107 4.130,4.47 C4.130,5.128 5.11,5.608 6.851,6.68 C9.732,6.788 11.32,7.868 11.32,10.309 Z"/>
        </svg>
        <div></div>
      </div>

      <div ref="c-btnNews" class="c-btnNews">
        <div class="c-btnNews__btn" @click="openNews">
          <div class="is-wrap">
            <span>NEWS!</span>
            <img :src="`${assets_path}img/common/hand.png`" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="p-main__works">
      <div
        v-for="(child, x) in works"
        :key="x"
        class="c-grid"
        :class="`c-grid--${(x % 3) + 1}`"
      >
        <div
          v-for="(work, y) in child"
          :key="y"
          class="c-grid__item"
          @click.prevent="openModal(work)"
        >
          <img :src="work.gallery[0]" :alt="`${work.client} ${work.title}`" />
          <dl>
            <dt>{{work.client}}</dt>
            <dd>{{work.title}}</dd>
          </dl>
        </div>
      </div>

      <div v-if="isMore" ref="p-main__worksMore" class="p-main__worksMore" @click="moreWorks">
        <p>
          MORE
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.5 15.5" width="15.5" height="15.5">
            <path fill-rule="evenodd"  stroke="rgb(255, 255, 255)" stroke-width="1px" stroke-linecap="butt" stroke-linejoin="miter" fill="rgb(255, 255, 255)" d="M14.499,8.499 L8.499,8.499 L8.499,14.499 L6.499,14.499 L6.499,8.499 L0.499,8.499 L0.499,6.499 L6.499,6.499 L6.499,0.499 L8.499,0.499 L8.499,6.499 L14.499,6.499 L14.499,8.499 Z"/>
          </svg>
        </p>
      </div>
    </div>

    <global-footer></global-footer>
  </div>
</template>

<script>
  import 'intersection-observer';
  import 'es6-promise/auto';
  import {breakpoint, assets_path} from '@/_constant/variables';
  import store from '@/_modules/stores';
  import GlobalFooter from '@/_components/global-footer.vue';
  import {gsap, Cubic, Elastic} from 'gsap';
  import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
  gsap.registerPlugin(ScrollToPlugin);

  export default {
    components: {
      GlobalFooter,
    },
    data() {
      return {
        breakpoint: breakpoint,
        assets_path: assets_path,
        ispc: true,
        isMore: true,
        perPage: 12,
        currentPage: 1,
        max: 0,
        adjust: {
          pc: {
            mv: 148,// 74 * 2
          },
          sp: {
            mv: 0
          }
        },
        styleLogo: '',
        //baseTop: {},
        baseWorks: [],
        works: [],
        bgMovie: '',
      }
    },
    store,
    watch: {
      $route(to, from) {
        //console.log(this.$store.getters.isTop);
      }
    },
    computed: {
      setStyleLogo: function() {
        return function () {
          return this.styleLogo;
        }
      },
    },
    mounted() {
      //console.log(this.$store.getters.isTop);
      //this.init();
      gsap.set(this.$refs['c-btnNews'], {scale: 0});
      this.$nextTick(this.init);
    },
    methods: {
      init() {
        //this.baseTop = this.$siteData.top;
        const rnd = this.randomInt(0, this.$siteData.top.bg_videos.length - 1);
        this.bgMovie = this.$siteData.top.bg_videos[rnd];
        this.baseWorks = this.$siteData.works.concat();
        this.max = this.baseWorks.length;

        this.observer = new IntersectionObserver(this.scroll, {
          root: null,
          rootMargin: '-10px 0px',
          threshold: 0
        });
        this.observer.observe(this.$refs['p-main__worksMore']);

        // works配列を3つごとのグループにする
        const works2 = this.appendWorks();
        this.works.push(...works2);

        this.$nextTick(this.init2);
      },
      init2() {
        this.observer2 = new IntersectionObserver(this.scroll2, {
          root: null,
          rootMargin: '-20% 0px',
          threshold: 0
        });
        this.observer2.observe(this.$refs['p-main__mv']);

        this.resize();
        window.addEventListener('resize', this.resize);

        gsap.to(this.$refs['c-btnNews'], {
          duration: 1.0,
          delay: 0.5,
          scale: 1,
          ease: Elastic.easeOut,
        });
      },
      scroll(entries) {
        if (this.$store.getters.isTop) {
          entries.forEach((entry, i) => {
            const target = entry.target;
            if (entry.isIntersecting) {
              this.moreWorks();
            }
          });
        }
      },
      scroll2(entries) {
        if (this.$store.getters.isTop) {
          entries.forEach((entry, i) => {
            const target = entry.target;
            this.$parent.$refs['GlobalHeader'].changeActive('scroll-works', entry.isIntersecting);
            this.$parent.$refs['SpHeader'].changeActive('scroll-works', entry.isIntersecting);
          });
        }
      },
      appendWorks() {
        // works配列を3つごとのグループにする
        let tmpWorks = [];
        for (let i = 0; i < this.perPage; i++) {
          if (this.baseWorks[i] === undefined) break;

          const p = Math.floor(i / 3);
          const c = i % 3;

          if (typeof tmpWorks[p] === 'undefined') tmpWorks[p] = [];
          tmpWorks[p][c] = this.baseWorks[i];
        }

        // 元配列から削除
        this.baseWorks.splice(0, this.perPage);

        if (this.baseWorks.length <= 0) {
          // MOREなし
          this.observer.unobserve(this.$refs['p-main__worksMore']);
          this.observer.disconnect();
          this.isMore = false;
        }

        return tmpWorks;
      },
      moreWorks() {
        this.currentPage++; //次のページ

        // works配列を3つごとのグループにする
        const works2 = this.appendWorks();
        this.works.push(...works2);
      },
      start() {

      },
      mvScroll() {
        let scrollY = 0;
        if (this.$store.getters.isPc) {
          //sp
          scrollY = window.innerHeight - 74;
        } else {
          //pc
          scrollY = window.innerHeight;
        }

        gsap.to(window, {
          duration: 0.7,
          scrollTo: {y: scrollY, autoKill: true},
          ease: Cubic.easeOut,
        });
      },
      openModal(work) {
        this.$router.push({ name: 'works', params: {id: work.id, data: work} });
      },
      openNews() {
        console.log(this.$store.getters.isOpenNews);
        if (this.$store.getters.isOpenNews) {
          this.$store.commit('setOpenNews', false);
        } else {
          this.$store.commit('setOpenNews', true);
        }
      },
      resize() {
        const winW = this.getBodyWidth();
        const winH = window.innerHeight;
        let mvH = winH;

        const imgW = 16;
        const imgH = 9;

        if (window.innerWidth > breakpoint) {
          this.ispc = true;
          mvH = winH - this.adjust.pc.mv;

          // ブラウザサイズにフィット
          const scale = Math.max(winW / imgW, mvH / imgH);
          const frameW = imgW * scale;
          const frameH = imgH * scale;
          const frameX = (winW - frameW) / 2;
          const frameY = (mvH - frameH) / 2;

          const f = this.$refs['video-frame'];
          f.style.width = `${winW}px`;
          f.style.height = `${mvH}px`;

          const m = this.$refs['video-src'];
          m.style.left = `${frameX}px`;
          m.style.top = `${frameY}px`;
          m.style.width = `${frameW}px`;
          m.style.height = `${frameH}px`;

          this.styleLogo = ((292 / 752) * mvH) + 'px;';

        } else {
          this.ispc = false;

          mvH = winH - this.adjust.sp.mv;

          if (this.preWidth !== winW) {
            /*
            if (this.spSet.hRatio < winW / winH) {
              // 固定する
              this.spSet.height = this.spSet.contentHeightRatio * winW;
            } else {
              this.spSet.height = Math.min(window.innerHeight, winW * this.spSet.wRatio) - winW - (winW * this.spSet.headHeightRatio);
            }
            */

            // ブラウザサイズにフィット
            const scale = Math.max(winW / imgW, mvH / imgH);
            const frameW = imgW * scale;
            const frameH = imgH * scale;
            const frameX = (winW - frameW) / 2;
            const frameY = (mvH - frameH) / 2;

            const f = this.$refs['video-frame'];
            f.style.width = `${winW}px`;
            f.style.height = `${mvH}px`;

            const m = this.$refs['video-src'];
            m.style.left = `${frameX}px`;
            m.style.top = `${frameY}px`;
            m.style.width = `${frameW}px`;
            m.style.height = `${frameH}px`;

            this.styleLogo = ((292 / 752) * mvH) + 'px;';
          }
        }

        this.preWidth = winW;
      },
      videoEvent(e) {
        if (e.type === 'canplay') {
          //console.log('canplay');
        } else if (e.type === 'canplaythrough') {
          //console.log('canplaythrough');
        } else if (e.type === 'ended') {
          // 再生終了
          //console.log('video 再生終了');
        } else if (e.type === 'loadstart') {
          //console.log('loadstart 読込み');
          this.$emit('ready-component');
        }
      },
      getBodyWidth() {
        return document.body.clientWidth || window.innerWidth;
      },
      randomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      },
      /*
      getMatchMedia() {
        return window.matchMedia('(max-width: 900px)').matches;
      },
      */
    }
  }
</script>
